const possibleVideoExtensions = ['.mp4', '.avi', '.mov', '.mkv']

export function getExtensionFromUrl(fileUrl) {
  const extension = possibleVideoExtensions.find(value => fileUrl.toLowerCase().includes(value))?.split('.').pop()
  return extension ? `video/${extension}` : undefined
}
